export default {"src":"/_next/static/media/Pause.4c4f36d4.svg","height":183,"width":183,"blurWidth":0,"blurHeight":0};